<template>
  <div id="TopBar">
    <router-link to="/" class="logo" aria-label="Seguros THB - Inicio">
      <img src="/img/logos/logo-t.png" alt="Seguros THB" />
    </router-link>

    <app-sidebar-nav
      style="visibility: hidden"
      @click="setIsUserSideBarOpen({ status: false, timeout: 0 })"
    ></app-sidebar-nav>

    <div id="user-sidebar">
      <div class="main-container">
        <div class="login-elements cursor-pointer" @click="toogleUserSidebar()">
          <div
            class="relative mx-1 rounded-full border inline-block border-primary h-8 w-8 flex justify-center items-center sm:h-10 sm:w-10"
          >
            <font-awesome-icon
              :icon="['fas', 'user']"
              class="fa-lg text-primary"
            />
          </div>

          <div
            class="relative hidden mx-2 inline-block h-8 flex justify-center items-center sm:flex sm:h-10"
          >
            {{ loggedIn && userData ? userData.name : "Iniciar sesión" }}
          </div>
        </div>

        <router-link
          v-if="loggedIn"
          to="/shopping-cart"
          class="flex justify-center items-center mr-3 cursor-pointer"
        >
          <div
            class="relative mx-1 sm:mx-5 h-8 w-8 flex justify-center items-center"
          >
            <font-awesome-icon
              :icon="['fas', 'shopping-cart']"
              class="fa-lg text-primary"
            />
            <div
              class="rounded-full absolute -top-2 -right-2 animate-pulse text-primary w-5 h-5 flex justify-center items-center"
            >
              {{ shopingCount }}
            </div>
          </div>
        </router-link>

        <div v-else class="flex justify-center items-center mr-3">
          <div
            class="relative mx-1 sm:mx-5 h-8 w-8 flex justify-center items-center"
          >
            <font-awesome-icon
              :icon="['fas', 'shopping-cart']"
              class="fa-lg text-primary"
            />
            <div
              class="rounded-full absolute -top-2 -right-2 animate-pulse text-primary w-5 h-5 flex justify-center items-center"
            >
              {{ shopingCount }}
            </div>
          </div>
        </div>
      </div>

      <app-user-sidebar
        :is_opened="isUserSideBarOpen"
        ref="usersidebar"
      ></app-user-sidebar>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

import SideBar from "@/components/Sidebar/SideBar.vue";
import UserSidebar from "@/components/UserSidebar/UserSidebar.vue";

export default {
  name: "topbar",
  components: {
    appSidebarNav: SideBar,
    appUserSidebar: UserSidebar,
  },
  computed: {
    ...mapGetters(["loggedIn", "userData"]),
    shopingCount() {
      return this.$store.state.ShoppingCarStore.shoppingCar
        ? this.$store.state.ShoppingCarStore.shoppingCar.carItems.length
        : 0;
    },
    isUserSideBarOpen() {
      return this.$store.state.GeneralConfigStore.isUserSideBarOpen;
    },
  },
  methods: {
    ...mapMutations(["toogleUserSidebar", "setIsUserSideBarOpen"]),
  },
};
</script>
